module.exports = __webpack_public_path__ + "img/09.13f7f595.jpg";